import { useState } from "react";

const COMMENTS = [
  {
    id: 1,
    initial: "夜",
    color: "bg-red-700",
    name: "夜里数星星",
    badge: "铁杆瓜友",
    time: "2 分钟前",
    text: "站内查找一下就全出来了，连带三年前那场旧瓜都在人物专题里串成线，太好扒了！",
    likes: 4820,
    replies: "182 回复",
    reply: "回复：隔壁扒出的对比图更绝，建议配原版一起看",
  },
  {
    id: 2,
    initial: "瓜",
    color: "bg-amber-600",
    name: "吃瓜群众甲",
    badge: "新到站",
    time: "9 分钟前",
    text: "这条事件查询热度涨得离谱，评论已经一边倒了，但感觉事情没那么简单。",
    likes: 2130,
    replies: "96 回复",
    reply: "回复：同意，再蹲个后续，别急着站队",
  },
  {
    id: 3,
    initial: "深",
    color: "bg-stone-700",
    name: "深扒选手",
    badge: "资深考古",
    time: "27 分钟前",
    text: "我把关键人物专题按时间线拉了一遍，有几处口径对不上，细节我整理在回复里了。",
    likes: 8950,
    replies: "341 回复",
    reply: "回复：蹲一个完整时间线整理！",
  },
  {
    id: 4,
    initial: "桃",
    color: "bg-orange-600",
    name: "桃桃乌龙",
    badge: "铁杆瓜友",
    time: "1 小时前",
    text: "关键词一搜全出来了，这站内查找属实好用，比我自己翻微博快多了。",
    likes: 1660,
    replies: "42 回复",
    reply: "回复：同感，收藏了以后吃瓜都来这",
  },
];

const TOPIC = {
  title: "「红毯风波」完整时间线到底有没有反转？",
  discuss: "9.4 万人正在参与讨论",
  agrees: 12800,
  shrugs: 5310,
  shares: 7260,
};

export default function HotComments() {
  const [liked, setLiked] = useState<number[]>([]);

  const toggle = (id: number) =>
    setLiked((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));

  return (
    <section id="hot" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
        {/* topic / interaction panel */}
        <div className="lg:col-span-4">
          <div className="flex items-center gap-2 text-sm font-semibold text-red-700">
            <span className="h-px w-8 bg-red-700"></span>
            现场热议 · 评论区氛围
          </div>
          <h2 className="font-serif-sc mt-3 text-balance text-2xl font-black leading-snug text-stone-900 md:text-3xl">
            这条瓜底下，吵得比台上还热闹
          </h2>

          <div className="paper-card mt-6 rounded-lg p-6">
            <p className="font-serif-sc text-lg font-bold leading-snug text-stone-900">{TOPIC.title}</p>
            <p className="mt-2 flex items-center gap-1.5 text-xs text-stone-500">
              <i className="ri-group-line w-4 h-4 flex items-center justify-center text-red-700"></i>
              {TOPIC.discuss}
            </p>

            <div className="mt-5 grid grid-cols-3 gap-2 text-center">
              <div className="rounded-md bg-stone-50 px-2 py-3">
                <p className="font-serif-sc text-xl font-black text-red-700">12.8k</p>
                <p className="mt-0.5 text-[11px] text-stone-500">认为有反转</p>
              </div>
              <div className="rounded-md bg-stone-50 px-2 py-3">
                <p className="font-serif-sc text-xl font-black text-amber-600">5.3k</p>
                <p className="mt-0.5 text-[11px] text-stone-500">持保留态度</p>
              </div>
              <div className="rounded-md bg-stone-50 px-2 py-3">
                <p className="font-serif-sc text-xl font-black text-stone-700">7.2k</p>
                <p className="mt-0.5 text-[11px] text-stone-500">转发收藏</p>
              </div>
            </div>

            <div className="mt-5 flex flex-col gap-2 sm:flex-row">
              <button
                type="button"
                className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-red-700 px-4 py-2.5 text-sm font-semibold text-[#f7f3eb] transition-colors hover:bg-red-800"
              >
                <i className="ri-thumb-up-fill w-4 h-4 flex items-center justify-center"></i>
                我也来表态
              </button>
              <button
                type="button"
                className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-stone-200 bg-white px-4 py-2.5 text-sm font-semibold text-stone-700 transition-colors hover:border-red-700 hover:text-red-700"
              >
                <i className="ri-share-forward-line w-4 h-4 flex items-center justify-center"></i>
                分享这条瓜
              </button>
            </div>

            <a
              href="#comment-input"
              className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium text-stone-500 hover:text-red-700"
            >
              <i className="ri-chat-voice-line w-4 h-4 flex items-center justify-center"></i>
              加入讨论，你的观点也会被收录进站内
            </a>
          </div>
        </div>

        {/* comment feed */}
        <div className="lg:col-span-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-xs text-stone-400">
              <i className="ri-fire-fill w-4 h-4 flex items-center justify-center text-red-700"></i>
              按热度排序 · 实时
            </div>
            <span className="text-xs text-stone-400">共 21,407 条评论</span>
          </div>

          <div className="mt-3 divide-y divide-stone-100">
            {COMMENTS.map((c) => {
              const isLiked = liked.includes(c.id);
              return (
                <div key={c.id} className="py-5">
                  <div className="flex gap-3">
                    <div
                      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${c.color} text-sm font-bold text-[#f7f3eb]`}
                    >
                      {c.initial}
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="text-sm font-bold text-stone-800">{c.name}</span>
                        <span className="rounded-sm bg-red-700/10 px-1.5 py-0.5 text-[10px] font-semibold text-red-700">
                          {c.badge}
                        </span>
                        <span className="text-xs text-stone-400">{c.time}</span>
                      </div>
                      <p className="mt-1.5 text-sm leading-6 text-stone-700">{c.text}</p>
                      <div className="mt-3 flex items-center gap-5">
                        <button
                          type="button"
                          onClick={() => toggle(c.id)}
                          className={`inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium transition-colors ${
                            isLiked ? "text-red-700" : "text-stone-500 hover:text-red-700"
                          }`}
                        >
                          <i className={`${isLiked ? "ri-thumb-up-fill" : "ri-thumb-up-line"} w-4 h-4 flex items-center justify-center`}></i>
                          {isLiked ? c.likes + 1 : c.likes}
                        </button>
                        <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-stone-500">
                          <i className="ri-chat-1-line w-4 h-4 flex items-center justify-center"></i>
                          {c.replies}
                        </span>
                        <button type="button" className="ml-auto inline-flex items-center gap-1 whitespace-nowrap text-xs text-stone-500 hover:text-red-700">
                          <i className="ri-reply-line w-4 h-4 flex items-center justify-center"></i>
                          回复
                        </button>
                      </div>
                      <div className="mt-3 rounded-md bg-stone-50 px-3 py-2 text-xs leading-5 text-stone-500">
                        {c.reply}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* comment input */}
          <div id="comment-input" className="paper-card mt-2 flex items-start gap-3 rounded-lg p-4">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-red-700 text-sm font-bold text-[#f7f3eb]">
              我
            </div>
            <div className="flex-1">
              <textarea
                rows={2}
                maxLength={500}
                placeholder="说说你的看法，观点会进入站内查找索引…"
                className="w-full resize-none rounded-md border border-stone-200 bg-white px-3 py-2 text-sm text-stone-800 placeholder:text-stone-400 focus:border-red-700 focus:outline-none focus:ring-2 focus:ring-red-700/10"
              />
              <div className="mt-2 flex items-center justify-between">
                <span className="text-[11px] text-stone-400">文明吃瓜 · 0/500</span>
                <button
                  type="button"
                  className="whitespace-nowrap rounded-md bg-red-700 px-4 py-2 text-xs font-semibold text-[#f7f3eb] transition-colors hover:bg-red-800"
                >
                  发布评论
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}